export function isJsonString(str) {
    let returnVal;
    try {
        returnVal = JSON.parse(str);
    } catch (e) {
        returnVal = false;
    }
    return returnVal;
}